module.exports = __webpack_public_path__ + "img/little_Gitl_w_Pink_sneakers.38f5f309.jpg";